import { ArrowRightOutlined, EnvironmentOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Form, Input, Modal, Row, Select } from 'antd';
import { Auth } from 'aws-amplify';
import dayjs from 'dayjs';
import gql from 'graphql-tag';
import Cookies from 'js-cookie';
import _ from 'lodash';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import { geolocated } from 'react-geolocated';
import PlacesAutocomplete from 'src/_shared/components/location/PlacesAutocomplete.jsx';
import { withRouter } from 'react-router-dom';
import {
	GetLoginUser,
	updateUser,
} from 'src/_shared/api/graphql/custom/users/';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import uuid from 'uuid/v4';
import { RouterContext } from '../../_shared/contexts';
import { getLocation, graphql, ml } from '../../_shared/services/utils.js';
import { requiredFields } from '../errorHandlersExtended';
import { PageItem } from './AddLocationPageItemComponent.jsx';
import { USStates } from './copy.js';
import { ExtendedLoginModal } from './extended-user-merge';
import {
	AddLocationBtn as AddLocationButton,
	AlertError,
	Card,
	CheckIcon,
	FormStyles,
	InputStyles2,
	LabelStyles,
	MiscText,
	SubTitleStyles,
	SubmitBtn as SubmitButton,
	SubmitBtnContainer as SubmitButtonContainer,
	TitleStyles,
	btnText as buttonText,
	errorStyles,
} from './newUserFormStyles.js';

class NewExtendedUserForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			address: '',
			geolocationAllowed: false,
			serverError: false,
			showMergeAccountModal: false,
			department: '',
			requiredErrors: {},
			tokenData: this.props.tokenData,
			loading: this.props.tokenData?.identities?.[0]?.providerName === 'Rush',
			redirectURL: this.props.redirectURL,
			submitting: false,
			currencyAbbrev: 'USD',
			multiLingualData: [],
			languageCode: 'US',
		};
	}

	async componentDidMount() {
		const permissions = await navigator.permissions.query({
			name: 'geolocation',
		});
		const geolocationAllowed = permissions?.state === 'granted';
		if (geolocationAllowed) this.getCurrentLocation();
		this.setState({ geolocationAllowed });

		const accountExists = this.props.contact?.extendedUserId;
		if (accountExists) {
			this.props.history.push({
				pathname: '/login',
				state: {
					warningMessage:
						'This account has already been registered. Please login using your credentials.',
				},
			});
		}

		await this.getMultiLingualData();

		const provider = this.props.tokenData?.identities?.[0]?.providerName;
		if (provider === 'Rush') {
			this.handleSubmit();
		}
	}

	componentDidUpdate() {
		const { submitting } = this.state;
		const accountExists = this.props.contact?.extendedUserId;
		if (accountExists && !submitting) {
			this.props.history.push({
				pathname: '/login',
				state: {
					warningMessage:
						'This account has already been registered. Please login using your credentials.',
				},
			});
		}
	}

	onAuthentication = (authToken, currentUser) => {
		try {
			const host = window.location.hostname;
			if (host === 'localhost') {
				Cookies.set('jwt', authToken);
			} else {
				Cookies.set('jwt', authToken, { secure: true, httpOnly: false });
			}

			this.setState({
				auth: true,
			});
		} catch (error) {
			console.log(error);
		}
	};

	onChange = (event_) => {
		const { value } = event_.target;
		this.setState({ currencyAbbrev: value });
	};

	getCurrentLocation = () => {
		if (navigator.geolocation) {
			// Timeout at 60000 milliseconds (60 seconds)
			const options = { timeout: 60_000 };
			navigator.geolocation.getCurrentPosition(
				this.showLocation,
				this.errorHandler,
				options
			);
		} else {
			console.log('Sorry, browser does not support geolocation!');
		}
	};

	async getMultiLingualData() {
		try {
			let multiLingualData = await graphql({
				input: { module: 'Registration' },
				query: 'queryMultiLingualByModuleIndex',
			});
			multiLingualData = multiLingualData?.items || multiLingualData;
			this.setState({
				multiLingualData,
			});
		} catch (error) {
			console.log(error);
		}
	}

	addLocation = async () => {
		if (this.props.isGeolocationAvailable) {
			const lat = this.props?.coords?.latitude;
			const lon = this.props?.coords?.longitude;
			const location = await getLocation({ lat, lon }, 'apiKey');
			this.setState({ address: location?.address, location });
		} else {
			console.log('Location is not available');
		}
	};

	errorHandler = (error) => {
		if (error.code == 1) {
			console.log('Error: Access is denied!');
		} else if (error.code == 2) {
			console.log('Error: Position is unavailable!');
		}
	};

	handleChangeLocation = (address) => {
		this.setState({ address });
	};

	handleSelectDepartment = (department) => {
		this.setState({ department });
	};

	handleSelectLocation = async (location) => {
		this.setState({ address: location?.address, location });
	};

	handleSubmit = async (values) => {
		const { contact, onCreate, onUpdateContact, setCurrentUser } = this.props;
		this.setState({ serverError: false, pageIsValid: true });

		if (this.pageIsValid(values)) {
			const userEmail = (values?.emailAddress || '')
				.split(' ')
				.join('')
				.toLowerCase();
			const existingUser = await graphql({
				input: { emailAddress: userEmail },
				query: 'getUserByEmailAddress',
			});
			if (existingUser) {
				this.setState({ emailError: true });
				this.setState({ loading: false, showMergeAccountModal: true });
			} else {
				this.setState({ submitting: true });
				Auth.signUp({
					username: uuid(),
					password: values.password,
					attributes: {
						email: userEmail,
					},
				}).then((data) => {
					const companyId =
						this.props.contact?.companyId ??
						'd5a17493-1e50-4a38-afa5-99623951d72e'; // Extended Network Company
					const input = {
						cognitoId: data?.user?.username,
						companyId,
						emailAddress: userEmail,
						extendedCompanies: JSON.stringify([contact?.companyId]),
						extendedContactIds: JSON.stringify([contact?.id]),
						inviteStatus: 'accepted',
						role: 'extendedUser',
						firstName: values?.firstName,
						lastName: values?.lastName,

						departmentId: 'f5da3fd2-2ae5-41c3-8c8c-b901b7ec8eb0',
						avatar: null,
						lastLogin: null,
						active: true,
						createdById: contact?.userId,
						userGroupId: '3391aa35-275b-47ee-a505-f59cbef37b42',
						currency: this.state?.currencyAbbrev || 'USD',
						languageCode: null,
					};
					if (this.state?.location)
						input.location = JSON.stringify(this.state.location);
					Auth.signIn(
						values.emailAddress.toLowerCase().trim(),
						values.password.trim()
					).then(async (user) => {
						onCreate({
							input,
						})
							.then((response) => {
								const extendedUserId = response?.data?.createUser?.id;
								onUpdateContact({
									input: {
										id: contact?.id,
										inviteStatus: 'accepted',
										extendedUserId,
									},
								});
							})
							.then(async () => {
								const { data } = await this.props.client.query({
									query: GetLoginUser,
									variables: {
										cognitoId: user.username,
										token: JSON.stringify(user),
									},
								});
								const currentUser = {
									...data.getLoginUser,
									authMethod: 'credentials',
									lastLogin: dayjs().toISOString(),
								};
								if (currentUser && !currentUser.active) {
									const error = new Error('User Disabled');
									error.code = 'UserDisabledException';
									throw error;
								} else {
									setCurrentUser(currentUser);
									await this.props.client.mutate({
										mutation: gql(updateUser),
										variables: {
											input: {
												id: currentUser.id,
												authMethod: 'credentials',
												lastLogin: dayjs().toISOString(),
												accessToken:
													user.signInUserSession.accessToken.jwtToken,
												expires: false,
											},
										},
									});
									this.props.onAuthentication(
										user.signInUserSession.accessToken.jwtToken,
										currentUser
									);
								}
							});
					});
				});
			}
		}
	};

	handleSubmitFailed = (errorInfo) => {
		this.setState({ loading: false, serverError: true });
	};

	pageIsValid = (values) => {
		let isValid = true;
		const requiredErrors = {};
		for (const { key, message } of requiredFields) {
			if (!values[key]) {
				requiredErrors[key] = message;
				isValid = false;
			}
		}

		this.setState({
			requiredErrors,
		});

		return isValid;
	};

	showLocation = async (position) => {
		const lat = position?.coords?.latitude;
		const lon = position?.coords?.longitude;
		const location = await getLocation({ lat, lon }, 'apiKey');
		this.setState({ address: location?.address, location });
	};

	renderLocation = () => {
		const { languageCode, multiLingualData } = this.state;
		const { Option } = Select;
		const options = [];
		Object.keys(USStates).map((key) =>
			options.push(<Option key={key}>{USStates[key]}</Option>)
		);
		return (
			<div>
				<PageItem>
					<Col md={24} xs={48}>
						<label className={LabelStyles}>
							{ml('Location', { languageCode }, multiLingualData)}
						</label>
						{this.state.geolocationAllowed && (
							<Button className={AddLocationButton} onClick={this.addLocation}>
								<EnvironmentOutlined />
								<span className={buttonText}>
									{ml('Autofill Location', { languageCode }, multiLingualData)}
								</span>
							</Button>
						)}
					</Col>
					<Col md={24} xs={16}>
						<div>
							<PlacesAutocomplete
								address={this.state.address}
								auth="apiKey"
								setAddress={this.handleChangeLocation.bind(this)}
								onSelect={this.handleSelectLocation.bind(this)}
							/>
						</div>
					</Col>
				</PageItem>
			</div>
		);
	};

	render() {
		const {
			loading,
			serverError,
			requiredErrors,
			showMergeAccountModal,
			submitting,
		} = this.state;

		const theme = null;
		const contact = this.props.contact;
		const firstName = contact?.firstName || '';
		const lastName = contact?.lastName || '';
		const emailAddress = contact?.emailAddress || '';

		const { multiLingualData, languageCode } = this.state;

		const Title1 = contact
			? ml(
					"Let's Get Started",
					{ languageCode },
					multiLingualData,
					'Registration'
				)
			: `We're Sorry`;
		const Title2 = contact
			? ml(
					'First complete your profile',
					{ languageCode },
					multiLingualData,
					'Registration'
				)
			: 'This invitation has expired.';
		const whiteLabel = this.props.whiteLabel;

		if (submitting) {
			return (
				<div className={Card}>
					<div style={{ width: '100%', height: 608 }}>
						<Spinner forceDefault />
					</div>
				</div>
			);
		}

		return (
			<div className={Card}>
				<div style={{ width: '100%' }}>
					{contact === undefined ? (
						<Row
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								height: 76,
							}}
						>
							<Spinner forceDefault />
						</Row>
					) : (
						<div>
							<Row
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<h1 className={TitleStyles}>{Title1}</h1>
							</Row>
							<Row
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<h2 className={SubTitleStyles}>{Title2}</h2>
							</Row>
						</div>
					)}
					{contact && (
						<Form
							className={FormStyles}
							onFinish={this.handleSubmit}
							onFinishFailed={this.handleSubmitFailed}
							initialValues={{
								firstName: firstName || '',
								lastName: lastName || '',
								emailAddress: emailAddress || '',
							}}
						>
							<Row>
								<Col md={11} xs={24}>
									<label className={LabelStyles}>
										{ml(
											'First Name',
											{ languageCode },
											multiLingualData,
											'Registration'
										)}
									</label>
									<Form.Item className={InputStyles2} name="firstName">
										<Input />
									</Form.Item>
									{requiredErrors && requiredErrors.firstName ? (
										<div>
											<p className={errorStyles}>
												{' '}
												{requiredErrors.firstName}{' '}
											</p>
										</div>
									) : null}
								</Col>
								<Col md={{ span: 12, offset: 1 }} xs={24}>
									<label className={LabelStyles}>
										{ml(
											'Last Name',
											{ languageCode },
											multiLingualData,
											'Registration'
										)}
									</label>
									<Form.Item className={InputStyles2} name="lastName">
										<Input />
									</Form.Item>
									{requiredErrors && requiredErrors.lastName ? (
										<div>
											<p className={errorStyles}> {requiredErrors.lastName} </p>
										</div>
									) : null}
								</Col>
							</Row>

							<Row>{this.renderLocation()}</Row>
							<label className={LabelStyles} style={{ marginTop: 20 }}>
								{ml(
									'Email Address',
									{ languageCode },
									multiLingualData,
									'Registration'
								)}
							</label>
							<Form.Item
								className={InputStyles2}
								name="emailAddress"
								rules={[
									{
										type: 'email',
										message: ml(
											'Not a valid email address.',
											{ languageCode },
											multiLingualData,
											'Registration'
										),
									},
								]}
							>
								<Input disabled={emailAddress} />
							</Form.Item>
							<label className={LabelStyles}>
								{ml(
									'Create Password',
									{ languageCode },
									multiLingualData,
									'Registration'
								)}
							</label>
							<Form.Item
								className={InputStyles2}
								name="password"
								rules={[
									{
										required: true,
										message: ml(
											'Password Required',
											{ languageCode },
											multiLingualData,
											'Registration'
										),
									},
									{
										validator: (_, value) => {
											if (value && value.length < 8) {
												return Promise.reject(
													new Error(
														ml(
															'Password must be at least 8 characters long.',
															{ languageCode },
															multiLingualData,
															'Registration'
														)
													)
												);
											}
											return Promise.resolve();
										},
									},
								]}
							>
								<Input.Password autoComplete="on" />
							</Form.Item>
							{requiredErrors && requiredErrors.password ? (
								<div>
									<p className={errorStyles}> {requiredErrors.password} </p>
								</div>
							) : null}
							{!whiteLabel && (
								<p className={MiscText}>
									{ml(
										'By creating a profile you agree to the ERIN',
										{ languageCode },
										multiLingualData,
										'Registration'
									)}{' '}
									<a
										href="http://erinapp.com/terms-of-use"
										rel="noopener noreferrer"
										target="_blank"
									>
										{ml(
											'Terms of Use',
											{ languageCode },
											multiLingualData,
											'Registration'
										)}
									</a>{' '}
									{ml(
										'and',
										{ languageCode },
										multiLingualData,
										'Registration'
									)}{' '}
									<a
										href="https://erinapp.com/privacy-policy"
										rel="noopener noreferrer"
										target="_blank"
									>
										{ml(
											'Privacy Policy,',
											{ languageCode },
											multiLingualData,
											'Registration'
										)}
									</a>{' '}
									{ml(
										'and agree that we can send you information about jobs and referrals at your company. You can opt out at any time.',
										{ languageCode },
										multiLingualData,
										'Registration'
									)}
								</p>
							)}
							{serverError ? (
								<Alert
									type="error"
									className={AlertError}
									message={ml(
										'There was a problem creating your account. Please try again.',
										{ languageCode },
										multiLingualData,
										'Registration'
									)}
								/>
							) : null}

							<Form.Item className={SubmitButtonContainer(theme)}>
								<Button
									className={SubmitButton(theme)}
									htmlType="submit"
									onClick={_.debounce(() => {}, 300, {
										leading: true,
										trailing: false,
									})}
								>
									{ml(
										'Get Started',
										{ languageCode },
										multiLingualData,
										'Registration'
									)}
									<ArrowRightOutlined className={CheckIcon} />
								</Button>
							</Form.Item>
						</Form>
					)}
					<Modal
						cancelButtonProps={{ style: { display: 'none' } }}
						open={loading}
						footer={null}
						closable={false}
						width="100%"
						bodyStyle={{
							backgroundColor: '#242e3f',
							height: window.innerHeight,
						}}
						style={{
							top: '0px',
						}}
					>
						<div
							style={{
								marginTop: '10%',
							}}
						>
							<Spinner forceDefault />
						</div>
					</Modal>
					<RouterContext.Consumer>
						{({ onAuthentication }) => (
							<ExtendedLoginModal
								visible={showMergeAccountModal}
								email={contact?.emailAddress}
								contact={contact}
								closeModal={() =>
									this.setState({ showMergeAccountModal: false })
								}
								client={this.props.client}
								onAuthentication={onAuthentication}
								onUpdateContact={this.props.onUpdateContact}
							/>
						)}
					</RouterContext.Consumer>
				</div>
			</div>
		);
	}
}

export default withApollo(
	withRouter(
		geolocated({
			positionOptions: {
				enableHighAccuracy: true,
			},
			userDecisionTimeout: 60_000,
		})(NewExtendedUserForm)
	)
);
